// extracted by mini-css-extract-plugin
export default {"SocialDiv":"SocialTemp_SocialDiv__oUvbD","socialIcon":"SocialTemp_socialIcon__n1L2I"};